import {Link} from "react-router-dom";
import { motion } from "framer-motion"
import ServiceNavbar from "../cpa/components/ServiceNavbar";
import "./styles/csu.scss";

function Cpa() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    學分班<br/>
                    <div className="fs-1 dis">
                    加州州立大學東灣分校
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <ServiceNavbar/>
            <div className="container csu-credits-page">
                {/* <!-- HERO --> */}
                <header className="hero" aria-label="The Bridging Program 介紹">
                {/* <!-- Top image (new) --> */}
                <figure className="hero-media" aria-label="Becker x CSUEB 合作學分班主視覺">
                    <img
                    src="/uploads/news/1767591043377_加州州立大學 x 捷進 Becker 會計師學分班_官網 banner.png"
                    alt="加州州立大學 x 捷進 Becker 會計師學分班"
                    loading="lazy"
                    decoding="async"
                    />
                </figure>

                <div className="hero-top">
                    <div>
                    <h1>The Bridging Program 美國會計師學分班介紹</h1>

                    <p className="subheadline">Becker x CSUEB 合作美國會計師學分班</p>
                    <p className="tagline">補足學分並同步準備美國會計師考試，一次到位</p>

                    <div className="badge-row" aria-label="重點標籤">
                        <span className="badge"><strong>開課年度</strong>：2026</span>
                        <span className="badge">Becker Taiwan (捷進顧問) × 加州州立大學東灣分校 (CSUEB)</span>
                        <span className="badge">中＋英模式</span>
                    </div>

                    <div className="divider" role="separator" aria-hidden="true"></div>

                    <p>每學期課程依照當下 U.S. CPA 考試範圍設計。因應2024年起考試改制、課程內容大幅改變，新年度學分班內容經學校再次嚴格審核與批准，爾後授予修畢者學分證明，2026 年 1 月，全新學期招生中！</p>
                    </div>

                    <aside className="hero-side" aria-label="關鍵資訊">
                    <h2>開課單位</h2>
                    <p>Becker Taiwan (捷進顧問) 與加州州立大學東灣分校 (California State University, East Bay) 合作開設。</p>

                    <div className="meta" aria-label="資訊卡">
                        <div className="meta-item">
                        <div className="meta-label">全部學分數總計</div>
                        <div className="meta-value">27</div>
                        </div>
                        <div className="meta-item">
                        <div className="meta-label">會計類學分數總計</div>
                        <div className="meta-value">24</div>
                        </div>
                        <div className="meta-item">
                        <div className="meta-label">商業類學分數總計</div>
                        <div className="meta-value">3</div>
                        </div>
                    </div>
                    </aside>
                </div>
                </header>

                <main className="grid" aria-label="內文">
                {/* <!-- 學分班之學分證明申請時程 --> */}
                <section className="section" aria-label="學分證明申請時程">
                    <div className="section-head">
                    <h2>學分班之學分證明申請時程</h2>
                    <span className="hint">向加州州立大學申請學分，各學期申請區間與截止日</span>
                    </div>

                    <div className="table-wrap" role="region" aria-label="各學期申請區間與截止日" tabindex="0">
                    <table>
                        <thead>
                        <tr>
                            <th style={{ width: '180px' }}>學期名稱</th>
                            <th style={{ width: '240px' }}>學期區間</th>
                            <th>必須完成學分班課程、作業、測驗之期限</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Spring semester</td>
                            <td>1月至5月15日</td>
                            <td>5月1日</td>
                        </tr>
                        <tr>
                            <td>Summer semester</td>
                            <td>6月至7月31日</td>
                            <td>7月15日</td>
                        </tr>
                        <tr>
                            <td>Fall semester</td>
                            <td>8月至12月15日</td>
                            <td>12月1日</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </section>

                {/* <!-- 各科課表（依課程代碼） --> */}
                <section className="section" aria-label="各科課表與進度（依課程代碼）">
                    <div className="section-head">
                    <h2>各科課表</h2>
                    <span className="hint">本期課程依照加州州立大學提供標準，安排週數與進度</span>
                    </div>

                    <div className="schedule-list" aria-label="依課程代碼逐列">
                    {/* <!-- ACCT 811c --> */}
                    <div className="schedule-row" aria-label="ACCT 811c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 811c</span>
                            <p className="schedule-title">Financial Accounting and Reporting I</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include conceptual framework, financial reporting, financial statements and disclosures.</p>
                            <p>此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括概念框架、財務報告、財務報表及揭露事項。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>F1 - Financial Reporting</li>
                            <li>F2 - Financial Reporting and Disclosures</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">F1、F2</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">F1 - 4.91 小時；F2 - 2.41 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 812c --> */}
                    <div className="schedule-row" aria-label="ACCT 812c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 812c</span>
                            <p className="schedule-title">Financial Accounting and Reporting II</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include monetary assets, inventory, property, plant and equipment, intangibles, investments, business combinations, and goodwill.</p>
                            <p>此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括貨幣性資產、存貨、土地廠房及設備、無形資產、投資、企業合併及商譽。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>F3 - Assets and Related Topics</li>
                            <li>F4 - Liabilities</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">F3、F4</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">F3 - 4.66 小時；F4 - 3.62 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 813c --> */}
                    <div className="schedule-row" aria-label="ACCT 813c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 813c</span>
                            <p className="schedule-title">Financial Accounting and Reporting III</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include investments, statements of cash flow, income taxes, nonprofit accounting, and governmental accounting.</p>
                            <p>此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括投資、現金流量表、所得稅、非營利組織會計及政府會計。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>F5 - Investments, Statement of Cash Flows, and Income Taxes</li>
                            <li>F6 - NFP Accounting and Governmental Accounting</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">9</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">F5、F6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">F5 - 3.4 小時；F6 - 3.48 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 816c --> */}
                    <div className="schedule-row" aria-label="ACCT 816c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 816c</span>
                            <p className="schedule-title">Auditing &amp; Attestation I</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include audit reports, professional standards, audit engagements, audit opinion, quality control, audit planning, and internal control.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括審計報告、專業標準、審計業務、審計意見、品質控制、審計規劃及內部控制。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>A1 - Audit Reports</li>
                            <li>A2 - Quality Control, Engagement Acceptance, Planning, and Internal Control</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">A1、A2</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">A1 - 3.14 小時；A2 - 3.88 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 817c --> */}
                    <div className="schedule-row" aria-label="ACCT 817c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 817c</span>
                            <p className="schedule-title">Auditing &amp; Attestation II</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include fraud, audit and engagement risk, evidence, sampling, performing further procedures, forming conclusions, and communications.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括舞弊、審計與業務風險、證據、抽樣、執行進一步程序、形成結論及溝通。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>A3 - Risk, Evidence, and Sampling</li>
                            <li>A4 - Performing Further Procedures, Forming Conclusions, and Communications</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">A3、A4</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">A3 - 6.09 小時；A4 - 2.6 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 818c --> */}
                    <div className="schedule-row" aria-label="ACCT 818c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 818c</span>
                            <p className="schedule-title">Auditing &amp; Attestation III</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include integrated audits, attestation engagements, compliance, government audits, accounting and review service, interim reviews, ethics, professional responsibilities.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括整合性審計、查證業務、合規性、政府審計、會計及審閱服務、中期審閱、倫理及專業責任。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>A5 - Integrated Audits, Attestation Engagements, Compliance, and Government Audits</li>
                            <li>A6 - Accounting and Review Service Engagements, Interim Reviews, and Ethics and Professional Responsibilities</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">A5、A6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">A5 - 4.02 小時；A6 - 5.46 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 819c --> */}
                    <div className="schedule-row" aria-label="ACCT 819c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 819c</span>
                            <p className="schedule-title">Federal Income Taxation I - Individuals</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate for U.S. federal taxation. Topics include individual taxation on filing requirements, gross income, adjustments, itemized deductions, tax computation, and property taxation on basis, dispositions, gains and losses.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在美國聯邦稅務方面必須具備的知識與技能。課程內容包括個人稅務的申報要求、總收入、調整項目、列舉扣除、稅額計算，以及財產稅務中基礎、處分、收益與損失。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>R1 - Individual Taxation: Part 1</li>
                            <li>R1 - Individual Taxation: Part 2 / R2 - Individual Taxation: Part 2</li>
                            <li>R2 - Individual Taxation: Part 2</li>
                            <li>R3 - Property Taxation</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">15</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">R1、R2</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">R1 - 2.95 小時；R2 - 1.39 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 820c --> */}
                    <div className="schedule-row" aria-label="ACCT 820c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 820c</span>
                            <p className="schedule-title">Federal Income Taxation II - Entities</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>會計類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills a CPA must demonstrate for U.S. federal taxation. Topics include corporate taxation, flow-through entity taxation and multi-jurisdictional tax issues, trusts and estates, gifts, tax-exempt organizations, professional responsibilities, and federal tax procedures.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在美國聯邦稅務方面必須具備的知識與技能。課程內容包括公司稅務、通過實體稅務、多管轄區稅務問題、信託及遺產、贈與、免稅組織、專業責任及聯邦稅務程序。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>R4 - Corporate Taxation</li>
                            <li>R4 contd</li>
                            <li>R5 - Entity Taxation</li>
                            <li>R6 - Ethics, Professional Responsibilities, and Federal Tax Procedures</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">12</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">R3、R4</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">R3 - 2.47 小時；R4 - 1.43 小時</p>
                        </div>
                    </div>

                    {/* <!-- ACCT 821c --> */}
                    <div className="schedule-row" aria-label="ACCT 821c">
                        <div className="schedule-head">
                        <div>
                            <span className="pill">ACCT 821c</span>
                            <p className="schedule-title">Business Law</p>
                        </div>
                        <div className="nowrap">
                            <p className="k" style={{margin:'0'}}>學分種類</p>
                            <p className="v nowrap" style={{margin:'2px 0 0'}}>商業類</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">教學範圍</p>
                        <div className="v teaching-scope">
                            <p>Course objectives are to provide the knowledge and skills that a CPA must demonstrate with respect to U.S. business law. Topics include agency, contracts, suretyship, secured transactions, bankruptcy, federal securities regulation, other federal laws and regulations, and business structures.</p>
                            <p>此門課的學習目標是提供美國註冊會計師（US CPA）在美國商法方面必須具備的知識與技能。課程內容包括代理、契約、保證、擔保交易、破產、聯邦證券法規、其他聯邦法律與法規，以及商業架構。</p>
                            <p>Will not satisfy course requirement in accounting degree program.</p>
                            <p>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。</p>
                            <p>Prerequisite: None</p>
                            <p>修課條件：無。</p>
                        </div>
                        </div>

                        <div className="kv">
                        <p className="k">授課範圍（一般學員）</p>
                        <div className="v">
                            <ul className="scope-list">
                            <li>R7 - Business Law: Part 1</li>
                            <li>R8 - Business Law: Part 2</li>
                            </ul>
                        </div>
                        </div>
                        <div className="kv">
                        <p className="k">中文授課時數 (小時)</p>
                        <p className="v">6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材／對應單元</p>
                        <p className="v">R5、R6</p>
                        </div>
                        <div className="kv">
                        <p className="k">Becker 教材 外師影片 授課時數 (小時)</p>
                        <p className="v">R5 - 6.85 小時；R6 - 5.21 小時</p>
                        </div>
                    </div>
                    </div>
                </section>

                {/* <!-- 評量方式 / 期末考試 / 選課身份 / 學分費用（直接顯示） --> */}
                <section className="section" data-section="assessment" aria-label="評量方式與費用">
                    <div className="section-head">
                    <h2>評量方式與費用</h2>
                    <span className="hint">考試方式、計分規則、報名資格一次看懂</span>
                    </div>

                    <div className="info-grid--four" aria-label="評量方式／期末考試／選課身份／學分費用">
                    {/* <!-- 評量方式 --> */}
                    <div className="info-box" aria-label="評量方式">
                        <h3>評量方式（每門學分班）</h3>
                        <ul className="bullets">
                        <li>完成 Becker Taiwan 中文課程（每堂 3 小時）並搭配美籍講師影片學習。</li>
                        <li>於 Becker CPA Exam Review 軟體完成該門課程單元範圍之單選題（MCQ）。</li>
                        <li>MCQ 完成百分比：成績占比 25%</li>
                        <li>MCQ 答題正確率：成績占比 25%</li>
                        <li>參加線上期末考（以答題正確率計）：成績占比 50%</li>
                        </ul>
                        <p className="mini">不同學分項目如有差異，以各門課程大綱為準。</p>
                    </div>

                    {/* <!-- 期末考試 --> */}
                    <div className="info-box" aria-label="期末考試">
                        <h3>期末考試</h3>
                        <ul className="bullets">
                        <li><strong>限時</strong>：120 分鐘</li>
                        <li><strong>題型</strong>：24–42 題單選題（MCQ）＋ 1–3 題情境模擬題（Simulation）</li>
                        <li><strong>應考方式</strong>：線上考（需預約）／實體考（需預約）</li>
                        <li><strong>線上考費用</strong>：US$20.00（ExamRoom.ai）</li>
                        <li><strong>實體考費用</strong>：免費（Becker Taiwan 台北大安教室）</li>
                        </ul>
                    </div>

                    {/* <!-- 選課身份 --> */}
                    <div className="info-box" aria-label="選課身份">
                        <h3>選課身份</h3>
                        <ul className="bullets">
                        <li>Becker Taiwan 之美國註冊會計師（CPA）軟體效期內之學員。</li>
                        </ul>
                    </div>

                    {/* <!-- 學分費用 --> */}
                    <div className="info-box" aria-label="學分費用">
                        <h3>學分費用 <span className="badge-strong">每門 3 學分</span></h3>
                        <ul className="bullets">
                        <li>定價：新台幣 30,000 元／門</li>
                        </ul>
                    </div>
                    </div>
                </section>

                {/* <!-- CTA (end) --> */}
                <section className="cta" aria-label="立即行動">
                    <div className="cta-head">
                    <p className="cta-title">下一步怎麼開始？</p>
                    <p className="cta-sub">
                        已是 Becker 學員嗎？請直接
                        <a
                        href="https://page.line.me/vtz1908l?openQrModal=true"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-link="line"
                        aria-label="LINE 聯繫顧問（開新視窗）"
                        >LINE</a>
                        聯繫顧問、確認是否須補修學分。
                    </p>
                    </div>

                    <div className="cta-actions" aria-label="CTA buttons">
                    <a
                        className="btn btn-secondary"
                        href="https://www.beckertw.com/consult"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cta="consult"
                        aria-label="免費評估報考資格、是否尚缺學分（開新視窗）"
                    >
                        免費評估報考資格、是否尚缺學分
                    </a>

                    <a
                        className="btn btn-primary"
                        href="https://www.beckertw.com/registration/plan?parent_id=5"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-cta="register"
                        aria-label="立即報名 Becker x CSU 學分班（開新視窗）"
                    >
                        立即報名 Becker x CSU 學分班
                    </a>
                    </div>

                    <p className="btn-note">若你不確定是否需要補學分，建議先完成免費評估；確認需求後再進行報名，可節省時間並提高完成效率。</p>
                </section>
                </main>
            </div>
        </>
    );
}
export default Cpa;